import UserWaypoints from './UserWaypoints';

export default UserWaypoints;
